import { motion } from 'framer-motion';
import { RefreshCw } from 'lucide-react';
import { FC, useState } from 'react';

interface RefreshListProps {
  onRefreshTable: () => Promise<void>;
  isRefreshing?: boolean;
  color?: string;
  hoverColor?: string;
  transitionDuration?: string;
  size?: number;
  animate?: boolean;
  stopAnimation?: () => void;
}

const RefreshList: FC<RefreshListProps> = ({
  onRefreshTable,
  isRefreshing = false,
  color,
  hoverColor,
  transitionDuration = '0.3s',
  size = 18,
  animate = false,
  stopAnimation = () => { }
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const hasColorOverrides = Boolean(color || hoverColor);
  const isActive = isRefreshing || isHovered;

  const handleClick = async () => {
    await onRefreshTable();
    stopAnimation();
  };

  // Estilos para la animación de palpitación
  const pulseAnimation = `
    @keyframes pulse {
      0%, 100% {
        transform: scale(1);
        rotate: 0deg;
      }
      50% {
        transform: scale(1.05);
        rotate: 20deg;
      }
    }
  `;

  return (
    <button
      type="button"
      title="Refrescar tabla"
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={
        'inline-flex h-9 w-9 items-center justify-center rounded-full transition hover:scale-110 ' +
        (hasColorOverrides
          ? ''
          : isActive
            ? 'text-secondary-600 dark:text-secondary-200'
            : 'text-inkMuted dark:text-inkMuted-dark')
      }
      style={
        hasColorOverrides
          ? {
            color: isActive ? hoverColor ?? color : color,
            transition: `all ${transitionDuration} ease`
          }
          : undefined
      }
    >
      <motion.span
        className="inline-flex"
        animate={
          isRefreshing
            ? { rotate: 360 }
            : animate
              ? { scale: [1, 1.15, 1] }
              : { rotate: 0, scale: 1 }
        }
        transition={
          isRefreshing
            ? { duration: 0.8, repeat: Infinity, ease: 'linear' }
            : animate
              ? { duration: 1.3, repeat: Infinity, ease: 'easeInOut' }
              : undefined
        }
      >
        <RefreshCw size={size} />
      </motion.span>
    </button>
  );
};

export default RefreshList;
